import produce from 'immer';
import { AnyAction } from 'redux';
import {
  PUT_REMOVE_WAIT_CANCEL_REQUEST,
  PUT_REMOVE_WAIT_CANCEL_SUCCESS,
  PUT_REMOVE_WAIT_CANCEL_FAILURE,
  PUT_REMOVE_WAIT_CANCEL_INITIAL,
} from '../../actions';

export type PutRemoveWaitCancelStateType = {
  isPutRemoveWaitCancelLoading: boolean;
  isPutRemoveWaitCancelLoaded: boolean;
};

const initialState: PutRemoveWaitCancelStateType = {
  isPutRemoveWaitCancelLoading: false,
  isPutRemoveWaitCancelLoaded: false,
};

const putRemoveWaitCancelReducer = (state = initialState, action: AnyAction): PutRemoveWaitCancelStateType => {
  return produce(state, (draft) => {
    const dataState = draft;
    switch (action.type) {
      case PUT_REMOVE_WAIT_CANCEL_REQUEST:
        dataState.isPutRemoveWaitCancelLoading = true;
        dataState.isPutRemoveWaitCancelLoaded = false;
        break;
      case PUT_REMOVE_WAIT_CANCEL_SUCCESS:
        dataState.isPutRemoveWaitCancelLoading = false;
        dataState.isPutRemoveWaitCancelLoaded = true;
        break;
      case PUT_REMOVE_WAIT_CANCEL_FAILURE:
        dataState.isPutRemoveWaitCancelLoading = false;
        dataState.isPutRemoveWaitCancelLoaded = false;
        break;
      case PUT_REMOVE_WAIT_CANCEL_INITIAL:
        dataState.isPutRemoveWaitCancelLoading = false;
        dataState.isPutRemoveWaitCancelLoaded = false;
        break;
      default:
        break;
    }
  });
};

export default putRemoveWaitCancelReducer;
